import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { useAcademyChatActions } from '../../context/AcademyChatActionsContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function AcademySuggestionButtons({
  section,
  stepListLabels,
  disabled
}) {
  var _section$actions;
  const chatActions = useAcademyChatActions();
  const labels = stepListLabels !== null && stepListLabels !== void 0 ? stepListLabels : section !== null && section !== void 0 && (_section$actions = section.actions) !== null && _section$actions !== void 0 && _section$actions.length ? section.actions.map(a => a.label) : [];
  if (!labels.length) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexWrap: "wrap",
    gap: "200",
    marginBlockStart: "400",
    children: labels.map(label => /*#__PURE__*/_jsx(Button, {
      use: "secondary",
      size: "extra-small",
      borderRadius: "full",
      disabled: disabled || chatActions.isStreaming,
      onClick: () => chatActions.onSuggestionClick(label),
      children: label
    }, label))
  });
}